module.exports = __webpack_public_path__ + "static/img/IMG_20240723_204658.e07489d3.jpg";